__turbopack_context__.v({
  "all-products-card": "GA2YEa_all-products-card",
  "all-products-desktop": "GA2YEa_all-products-desktop",
  "all-products-fallback": "GA2YEa_all-products-fallback",
  "bento-card": "GA2YEa_bento-card",
  "content": "GA2YEa_content",
  "content-container": "GA2YEa_content-container",
  "corporate-head": "GA2YEa_corporate-head",
  "image-container": "GA2YEa_image-container",
  "light": "GA2YEa_light",
  "m1": "GA2YEa_m1",
  "root": "GA2YEa_root",
  "single-card": "GA2YEa_single-card",
  "tag": "GA2YEa_tag",
});
